import { useState, useEffect } from 'react';
import Modal from './Modal';
import './CustomerSelectionModal.css';

export default function CustomerSelectionModal({ isOpen, reason, newCustomers, allCustomers, currentCustomerIds, onSave }) {
  const [selected, setSelected] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Vorauswahl beim Öffnen setzen
  useEffect(() => {
    if (isOpen) {
      setSelected(new Set(currentCustomerIds || []));
      setError('');
    }
  }, [isOpen, currentCustomerIds]);

  const toggle = (id) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const handleSave = async () => {
    if (selected.size === 0) {
      setError('Bitte wähle mindestens einen Kunden aus.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await onSave([...selected]);
    } catch (err) {
      setError(err.message || 'Fehler beim Speichern');
      setLoading(false);
    }
  };

  const isNew = (id) => newCustomers?.some(c => c.id === id);

  const title = reason === 'new_customers'
    ? '🆕 Neue Kunden verfügbar'
    : '🏢 Welche Kunden fährst du an?';

  const description = reason === 'new_customers'
    ? `Es wurden neue Kunden zum System hinzugefügt. Bitte aktualisiere deine Auswahl.`
    : 'Bitte wähle alle Kunden aus, die du regelmäßig anfährst. Diese Angabe hilft dem System, dir relevante Informationen anzuzeigen.';

  return (
    <Modal
      isOpen={isOpen}
      title={title}
      type="info"
      onClose={() => {}}
      actions={
        <button
          type="button"
          className="modal-button modal-button-primary"
          disabled={loading || selected.size === 0}
          onClick={handleSave}
        >
          {loading ? 'Speichern...' : `Auswahl speichern (${selected.size})`}
        </button>
      }
    >
      <div className="customer-selection-modal">
        <p className="customer-selection-desc">{description}</p>

        {reason === 'new_customers' && newCustomers?.length > 0 && (
          <div className="customer-selection-new-hint">
            ✨ Neu hinzugekommen: {newCustomers.map(c => c.name).join(', ')}
          </div>
        )}

        {error && (
          <div className="customer-selection-error">⚠️ {error}</div>
        )}

        <div className="customer-selection-list">
          {allCustomers?.map(customer => (
            <label
              key={customer.id}
              className={`customer-selection-item${selected.has(customer.id) ? ' selected' : ''}${isNew(customer.id) ? ' is-new' : ''}`}
            >
              <input
                type="checkbox"
                checked={selected.has(customer.id)}
                onChange={() => toggle(customer.id)}
              />
              <span className="customer-selection-name">
                {customer.name}
                {isNew(customer.id) && <span className="customer-selection-badge">Neu</span>}
              </span>
            </label>
          ))}
        </div>

        <p className="customer-selection-hint">
          Du kannst deine Auswahl jederzeit in den Einstellungen unter „Kunden" anpassen.
        </p>
      </div>
    </Modal>
  );
}
